/**
 * Locale-aware display names for known accounts.
 * DB `name` stays English; JA shows katakana via map.
 * If DB was previously overwritten with katakana, EN still maps back.
 */
const JA_DISPLAY_NAMES: Record<string, string> = {
  tumati_tejasri_super: "トゥマティ・テジャスリ",
  "tumati tejasri": "トゥマティ・テジャスリ",
};

const EN_DISPLAY_NAMES: Record<string, string> = {
  tumati_tejasri_super: "Tumati Tejasri",
  "トゥマティ・テジャスリ": "Tumati Tejasri",
};

export function getLocalizedDisplayName(
  user: { name?: string | null; username?: string | null } | null | undefined,
  locale: string,
): string {
  const fallback = user?.name?.trim() || user?.username?.trim() || "";
  if (!fallback) return "";

  const lang = locale.split("-")[0] ?? "en";
  const usernameKey = user?.username?.toLowerCase() ?? "";

  if (lang === "ja") {
    return (
      JA_DISPLAY_NAMES[usernameKey] ??
      JA_DISPLAY_NAMES[fallback.toLowerCase()] ??
      fallback
    );
  }

  return (
    EN_DISPLAY_NAMES[usernameKey] ?? EN_DISPLAY_NAMES[fallback] ?? fallback
  );
}

export function getLocalizedFirstName(
  user: { name?: string | null; username?: string | null } | null | undefined,
  locale: string,
): string {
  const full = getLocalizedDisplayName(user, locale);
  return full.split(/\s+|・/)[0] ?? full;
}
